/**
 * Reducer to fetch categories of an inspection project.
 */

import axios from 'axios';
import { AsyncAction } from '..';
import { ProjectCategory } from '../../types/project';

type State = {
    fetching: boolean;
    items: { [id: number]: ProjectCategory };
    error?: Error;
};

type Action = { type: 'project_category/get'; payload?: { items: State['items'] }; error?: Error };

const initialState: State = {
    fetching: false,
    items: {},
};

export const reducer = (state = initialState, action: Action): State => {
    switch (action.type) {
        case 'project_category/get':
            if (action.payload) return { ...state, fetching: false, ...action.payload };
            if (action.error) return { ...state, fetching: false, error: action.error };
            return { ...state, fetching: true };
        default:
            return state;
    }
};

/**
 * Request all project categories from the server.
 * 
  @param rethrow throw the internal error, causing the promise generated by the dispatch to fail
 */
const get = (rethrow = false): AsyncAction => async dispatch => {
    try {
        dispatch({ type: 'project_category/get' });
        const cancel = axios.CancelToken.source();
        dispatch({ type: 'cancel/set', payload: { 'project_category/get': cancel } });
        const response = await axios.get<ProjectCategory[]>('/inspection-categories/', { cancelToken: cancel.token });
        const items = response.data.reduce<State['items']>((acc, t) => ((acc[t.id] = t), acc), {});
        dispatch({ type: 'project_category/get', payload: { items } });
    } catch (error) {
        dispatch({ type: 'project_category/get', error });
        if (rethrow) throw error;
    }
};

export const creators = { get };
